module.exports = function () {
	let ua = navigator.userAgent;
	let tem;
	let match = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
	let browser = [];

	if ( /trident/i.test(match[1]) ) {
		tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
		browser.name = 'IE';
		browser.version = (tem[1] || '');
	}

	if ( match[1] === 'Chrome' ) {
		tem = ua.match(/\b(OPR|Edge)\/(\d+)/);

		if ( tem !== null ) {
			browser.name = tem[1].replace('OPR', 'Opera');
			browser.version = tem[2];
		}
	}

	match = match[2] ? [match[1], match[2]] : [navigator.appName, navigator.appVersion, '-?'];

	if ( (tem = ua.match(/version\/(\d+)/i) ) !== null ) {
		match.splice(1, 1, tem[1]);
		browser.name = match[0];
		browser.version = match[1];
	}

	browser.mobile = false;

	if ( ua.match(/(iPad|iPhone|iPod)/g) ) {
		browser.mobile = 'ios';
	} else if ( ua.match(/(android|Android)/g) ) {
		browser.mobile = 'android';
	}

	return browser;
};
